export enum ItemType {
  OPERATOR_ITEM_TYPE = 'operator',
  DEPARTMENT_ITEM_TYPE = 'department'
}
